import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import MissionVision from "../pages/mission-vision/page";
import Services from "../pages/services/page";
import Security from "../pages/security/page";
import Contact from "../pages/contact/page";
import Login from "../pages/login/page";
import Signup from "../pages/signup/page";
import Support from "../pages/support/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Careers from "../pages/careers/page";
import Cookies from "../pages/cookies/page";
import AdminCareers from "../pages/admin/careers/page";
import AdminSettings from "../pages/admin/settings/page";
import ServicesDetail from "@/pages/services/detail/page";
import AgentsRequest from "@/pages/agents-request/page";
import Investment from "@/pages/investment/page";
import FounderMessage from "../pages/founder-message/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/founder-message",
        element: <FounderMessage />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/mission-vision",
        element: <MissionVision />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/services/:serviceId",
        element: <ServicesDetail />,
      },
      {
        path: "/security",
        element: <Security />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/support",
        element: <Support />,
      },
      {
        path: "/privacy",
        element: <Privacy />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      {
        path: "/careers",
        element: <Careers />,
      },
      {
        path: "/cookies",
        element: <Cookies />,
      },
      {
        path: "/agents-request",
        element: <AgentsRequest />,
      },
      {
        path: "/investment",
        element: <Investment />,
      },
      {
        path: "/admin/careers",
        element: <AdminCareers />,
      },
      {
        path: "/admin/settings",
        element: <AdminSettings />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;